<template>
  <div class="w-full h-full z-50">
    <div class="flex justify-between mx-7 md:mx-12 mt-4">
      <div>
        <p class="text-3xl">
          {{ project.title }}
        </p>
        <p class="text-xl text-gray-400">
          {{ $t(project.work) }}
        </p>
      </div>
      <div @click="infoShow" class="flex justify-end cursor-pointer z-50">
        <Icon icon="iwwa:close" width="55px" weight="light" />
      </div>
    </div>
    <div class="h-full over-scroll pb-14 mx-7 md:mx-12 mt-4">
      <div>
        <p
          class="text-lg pt-2"
          v-for="(process, index) in process"
          :key="index"
        >
          {{ $t(process.text) }}
        </p>
      </div>
      <div class="mt-8">
        <div class="flex" v-for="(info, index) in processInfo" :key="index">
          <p class="text-sm">{{ $t(info.title) }}</p>
          <p class="text-sm text-gray-400 pl-1">{{ info.subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    process: {
      type: Array,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    processInfo: {
      type: Array,
      required: true,
    },
  },
  methods: {
    infoShow() {
      this.$emit("info-show");
    },
  },
};
</script>

<style>
.over-scroll {
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.over-scroll::-webkit-scrollbar {
  display: none;
}
</style>

